export function getFirebaseConfig() {

  //For production, return b5-production firebase app config
  //This value is passed in via package.json
  if (process.env.REACT_APP_FIREBASE_CONFIG === "production") {
    return {
      apiKey: "AIzaSyBHMr8JwgFYlhp4NIt-A35uxiuVLZuRrtU",
      authDomain: "b5-production-38c4f.firebaseapp.com",
      databaseURL: "https://b5-production-38c4f.firebaseio.com",
      projectId: "b5-production-38c4f",
      storageBucket: "b5-production-38c4f.appspot.com",
      messagingSenderId: "732036237587"
    };
  }


  //Default: return the b5-prototype config settings
  //This is for local and stage
  return {
    apiKey: "AIzaSyBnQIfb1-JklN-7RyQW1lxImiiojahov-0",
    authDomain: "b5-prototype.firebaseapp.com",
    databaseURL: "https://b5-prototype.firebaseio.com",
    storageBucket: "b5-prototype.appspot.com",
    messagingSenderId: "683372399292"
  };
}


// WEBPACK FOOTER //
// ./src/firebase-env-setup.js